import { materials } from "@/mocks/homeData";

export default function Materials() {
  return (
    <section id="materials" className="border-t border-background-200 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-5xl px-4 md:px-8">
        <div className="max-w-2xl">
          <p className="flex items-center gap-2 text-xs font-semibold tracking-[0.25em] text-primary-600 md:text-sm">
            <i className="ri-folder-open-line"></i>
            DEEP DIVE
          </p>
          <h2 className="mt-3 font-heading text-3xl font-black text-foreground-950 md:text-5xl">深挖材料</h2>
          <p className="mt-4 text-sm leading-loose text-foreground-600 md:text-base">
            不止停在标题。这里把原始材料、对照表与时间线放在一起，图文对照着看，比只看一条快讯更容易看清来龙去脉。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 md:gap-8">
          {materials.map((item) => (
            <a
              key={item.id}
              href="#entries"
              className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors hover:border-primary-300"
            >
              <div className="relative h-48 w-full overflow-hidden md:h-56">
                <img
                  src={item.image}
                  alt={`${item.title} 相关深挖材料配图`}
                  title={`${item.title} 黑料bu爆料 材料库`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 rounded-full bg-background-50/90 px-3 py-1 text-[11px] font-medium text-foreground-800">
                  {item.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5 md:p-6">
                <h3 className="font-heading text-lg font-bold text-foreground-950 transition-colors group-hover:text-primary-600 md:text-xl">
                  {item.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-loose text-foreground-600">{item.excerpt}</p>
                <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4">
                  <span className="flex items-center gap-1.5 text-xs text-foreground-400">
                    <i className="ri-eye-line"></i>
                    {item.readCount} 次浏览
                  </span>
                  <span className="flex items-center gap-1 text-xs font-semibold text-primary-600">
                    进入材料
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}